import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "_mt-0 _mb-0 _ml-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.benefits, (benefit) => {
      return (_openBlock(), _createElementBlock("li", {
        key: benefit,
        class: "gfu-bullet-list__item gfu-bullet-list__item--check gfu-bullet-list__item--secondary _tc--gray"
      }, _toDisplayString(benefit), 1 /* TEXT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}